const WEIGHTS = [
  { value: "--", label: "Select Weight..." , dataMetric:  "Select Weight..." },
  { value: "40", label: "< 40 lbs." , dataMetric:  "< 18.14 kg" },
  { value: "45", label: "< 45 lbs." , dataMetric:  "< 20.41 kg" },
  { value: "50", label: "< 50 lbs." , dataMetric:  "< 22.68 kg" },
  { value: "55", label: "< 55 lbs." , dataMetric:  "< 24.95 kg" },
  { value: "60", label: "< 60 lbs." , dataMetric:  "< 27.22 kg" },
  { value: "65", label: "< 65 lbs." , dataMetric:  "< 29.48 kg" },
  { value: "70", label: "< 70 lbs." , dataMetric:  "< 31.75 kg" },
  { value: "75", label: "< 75 lbs." , dataMetric:  "< 34.02 kg" },
  { value: "80", label: "< 80 lbs." , dataMetric:  "< 36.29 kg" },
  { value: "85", label: "< 85 lbs." , dataMetric:  "< 38.56 kg" },
  { value: "90", label: "< 90 lbs." , dataMetric:  "< 40.82 kg" },
  { value: "95", label: "< 95 lbs." , dataMetric:  "< 43.09 kg" },
  { value: "100", label: "100 lbs." , dataMetric:  "45.36 kg" },
  { value: "105", label: "105 lbs." , dataMetric:  "47.63 kg" },
  { value: "110", label: "110 lbs." , dataMetric:  "49.90 kg" },
  { value: "115", label: "115 lbs." , dataMetric:  "52.16 kg" },
  { value: "120", label: "120 lbs." , dataMetric:  "54.43 kg" },
  { value: "125", label: "125 lbs." , dataMetric:  "56.70 kg" },
  { value: "130", label: "130 lbs." , dataMetric:  "58.97 kg" },
  { value: "135", label: "135 lbs." , dataMetric:  "61.24 kg" },
  { value: "140", label: "140 lbs." , dataMetric:  "63.50 kg" },
  { value: "145", label: "145 lbs." , dataMetric:  "65.77 kg" },
  { value: "150", label: "150 lbs." , dataMetric:  "68.04 kg" },
  { value: "155", label: "155 lbs." , dataMetric:  "70.31 kg" },
  { value: "160", label: "160 lbs." , dataMetric:  "72.58 kg" },
  { value: "165", label: "165 lbs." , dataMetric:  "74.84 kg" },
  { value: "170", label: "170 lbs." , dataMetric:  "77.11 kg" },
  { value: "175", label: "175 lbs." , dataMetric:  "79.38 kg" },
  { value: "180", label: "180 lbs." , dataMetric:  "81.65 kg" },
  { value: "185", label: "185 lbs." , dataMetric:  "83.92 kg" },
  { value: "190", label: "190 lbs." , dataMetric:  "86.18 kg" },
  { value: "195", label: "195 lbs." , dataMetric:  "88.45 kg" },
  { value: "200", label: "200 lbs." , dataMetric:  "90.72 kg" },
  { value: "205", label: "205 lbs." , dataMetric:  "92.99 kg" },
  { value: "210", label: "210 lbs." , dataMetric:  "95.26 kg" },
  { value: "215", label: "215 lbs." , dataMetric:  "97.52 kg" },
  { value: "220", label: "220 lbs." , dataMetric:  "99.79 kg" },
  { value: "225", label: "225 lbs." , dataMetric:  "102.06 kg" },
  { value: "230", label: "230 lbs." , dataMetric:  "104.33 kg" },
  { value: "235", label: "235 lbs." , dataMetric:  "106.60 kg" },
  { value: "240", label: "240 lbs." , dataMetric:  "108.86 kg" },
  { value: "245", label: "245 lbs." , dataMetric:  "111.13 kg" },
  { value: "250", label: "250 lbs." , dataMetric:  "113.40 kg" },
  { value: "255", label: "255 lbs." , dataMetric:  "115.67 kg" },
  { value: "260", label: "260 lbs." , dataMetric:  "117.94 kg" },
  { value: "265", label: "265 lbs." , dataMetric:  "120.20 kg" },
  { value: "270", label: "270 lbs." , dataMetric:  "122.47 kg" },
  { value: "275", label: "275 lbs." , dataMetric:  "124.74 kg" },
  { value: "280", label: "280 lbs." , dataMetric:  "127.01 kg" },
  { value: "285", label: "285 lbs." , dataMetric:  "129.28 kg" },
  { value: "290", label: "290 lbs." , dataMetric:  "131.54 kg" },
  { value: "295", label: "295 lbs." , dataMetric:  "133.81 kg" },
  { value: "300", label: "300 lbs." , dataMetric:  "136.08 kg" },
  { value: "301", label: "> 300 lbs." , dataMetric:  "> 136.08 kg" },
];


const HEIGHTS = [
  { value: "--", label: "Select Height...", dataMetric: "Select Height..." },
  { value: "101.6", label: "< 3'4\"", dataMetric: "< 101.6 cm" },
  { value: "104.14", label: "< 3'5\"", dataMetric: "< 104.14 cm" },
  { value: "106.68", label: "< 3'6\"", dataMetric: "< 106.68 cm" },
  { value: "109.22", label: "< 3'7\"", dataMetric: "< 109.22 cm" },
  { value: "111.76", label: "< 3'8\"", dataMetric: "< 111.76 cm" },
  { value: "114.3", label: "< 3'9\"", dataMetric: "< 114.3 cm" },
  { value: "116.84", label: "< 3'10\"", dataMetric: "< 116.84 cm" },
  { value: "119.38", label: "< 3'11\"", dataMetric: "< 119.38 cm" },
  { value: "121.92", label: "< 4'", dataMetric: "< 121.92 cm" },
  { value: "124.46", label: "4'1\"", dataMetric: "124.46 cm" },
  { value: "127", label: "4'2\"", dataMetric: "127 cm" },
  { value: "129.54", label: "4'3\"", dataMetric: "129.54 cm" },
  { value: "132.08", label: "4'4\"", dataMetric: "132.08 cm" },
  { value: "134.62", label: "4'5\"", dataMetric: "134.62 cm" },
  { value: "137.16", label: "4'6\"", dataMetric: "137.16 cm" },
  { value: "139.7", label: "4'7\"", dataMetric: "139.7 cm" },
  { value: "142.24", label: "4'8\"", dataMetric: "142.24 cm" },
  { value: "144.78", label: "4'9\"", dataMetric: "144.78 cm" },
  { value: "147.32", label: "4'10\"", dataMetric: "147.32 cm" },
  { value: "149.86", label: "4'11\"", dataMetric: "149.86 cm" },
  { value: "152.4", label: "5'", dataMetric: "152.4 cm" },
  { value: "154.94", label: "5'1\"", dataMetric: "154.94 cm" },
  { value: "157.48", label: "5'2\"", dataMetric: "157.48 cm" },
  { value: "160.02", label: "5'3\"", dataMetric: "160.02 cm" },
  { value: "162.56", label: "5'4\"", dataMetric: "162.56 cm" },
  { value: "165.1", label: "5'5\"", dataMetric: "165.1 cm" },
  { value: "167.64", label: "5'6\"", dataMetric: "167.64 cm" },
  { value: "170.18", label: "5'7\"", dataMetric: "170.18 cm" },
  { value: "172.72", label: "5'8\"", dataMetric: "172.72 cm" },
  { value: "175.26", label: "5'9\"", dataMetric: "175.26 cm" },
  { value: "177.8", label: "5'10\"", dataMetric: "177.8 cm" },
  { value: "180.34", label: "5'11\"", dataMetric: "180.34 cm" },
  { value: "182.88", label: "6'", dataMetric: "182.88 cm" },
  { value: "185.42", label: "6'1\"", dataMetric: "185.42 cm" },
  { value: "187.96", label: "6'2\"", dataMetric: "187.96 cm" },
  { value: "190.5", label: "6'3\"", dataMetric: "190.5 cm" },
  { value: "193.04", label: "6'4\"", dataMetric: "193.04 cm" },
  { value: "195.58", label: "6'5\"", dataMetric: "195.58 cm" },
  { value: "198.12", label: "6'6\"", dataMetric: "198.12 cm" },
  { value: "200.66", label: "6'7\"", dataMetric: "200.66 cm" },
  { value: "203.2", label: "6'8\"", dataMetric: "203.2 cm" },
  { value: "204", label: "> 6'8\"", dataMetric: "> 204 cm" },
];


function getRecommendedFlex({ weight, height, flexMap }) {
  let flex = 0;
  if (weight <= 55 && weight >= 40) {
    weight = 55;
  } else if (weight <= 65 && weight >= 60) {
    weight = 65;
  } else if (weight <= 80 && weight >= 70) {
    weight = 80;
  } else if (weight <= 90 && weight >= 85) {
    weight = 90;
  } else if (weight <= 105 && weight >= 95) {
    weight = 105;
  } else if (weight >= 300) {
    weight = 300;
  }
  let flexAr = flexMap[weight][0].flex;

  for (let j = 0; j <= flexAr.length - 1; j++) {
    let heightArray = Object.values(Object.values(flexAr)[j])[0];
    let minHeight = heightArray[0];
    let maxHeight = heightArray[1];
    if (height <= maxHeight && height >= minHeight) {
      flex = Object.keys(flexAr[j])[0];
    }
  }
  return flex;
}

class FlexGuide extends HTMLElement {
  constructor() {
    super();
    // Create a shadow DOM
    this.attachShadow({ mode: "open" });
    // Define the HTML content of the component
    this.shadowRoot.innerHTML = `<slot></slot>`;
  }

  connectedCallback() {
    // Get select elements
    const select1 = document.getElementById("select1");
    const select2 = document.getElementById("select2");
    const result = document.getElementById("result");
    const checkbox = document.getElementById("toggle-btn-flex");
    select2.innerHTML = ' ';
    select1.innerHTML = ' ';
    WEIGHTS.forEach((item) => {
      const option = document.createElement("option");
      option.value = item.value;
      option.textContent = item.label;
      select1.appendChild(option);
    });

    
     HEIGHTS.forEach((item) => {
      const option = document.createElement("option");
      option.value = item.value;
      option.textContent = item.label;
      select2.appendChild(option);
    });
    checkbox.onchange = function() {
      if (this.checked) {
        select2.innerHTML = ' ';
        select1.innerHTML = ' ';
        result.textContent = "--"; // Display default value if either dropdown has not been selected
          HEIGHTS.forEach((item) => {
            const option = document.createElement("option");
            option.value = item.value;
            option.textContent = item.dataMetric;
            select2.appendChild(option);
          });
          WEIGHTS.forEach((item) => {
          const option = document.createElement("option");
          option.value = item.value;
          option.textContent = item.dataMetric;
          select1.appendChild(option);
        });
      } else {
          select2.innerHTML = ' ';
          select1.innerHTML = ' ';
          result.textContent = "--"; // Display default value if either dropdown has not been selected
          console.log("Checkbox is unchecked");
           HEIGHTS.forEach((item) => {
            const option = document.createElement("option");
            option.value = item.value;
            option.textContent = item.label;
            select2.appendChild(option);
          });
          WEIGHTS.forEach((item) => {
            const option = document.createElement("option");
            option.value = item.value;
            option.textContent = item.label;
            select1.appendChild(option);
        });
      }
    };

    select1.addEventListener("change", () =>
      this.updateResult(select1, select2, result)
    );
    select2.addEventListener("change", () =>
      this.updateResult(select1, select2, result)
    );
  }
  updateResult(select1, select2, result) {
  const selectedOption1 = select1.options[select1.selectedIndex].value;
  const selectedOption2 = select2.options[select2.selectedIndex].value;

  // Check if both dropdowns have selected options
  if (selectedOption1 !== "--" && selectedOption2 !== "--") {
    const recommendedFlex = getRecommendedFlex({
      weight: selectedOption1,
      height: selectedOption2,
      flexMap,
    });
    result.textContent = recommendedFlex;
  } else {
    result.textContent = "--"; // Display default value if either dropdown has not been selected
  }
}

}

// Define the custom element 'flex-guide'
customElements.define("flex-guide", FlexGuide);

